export default __webpack_public_path__ + "static/media/access_control_locations_icons_data_center.99ae33ea.svg";